module.exports = __webpack_public_path__ + "static/media/talk00_medium@2x.49aa15a3.jpg";